/** Bind the first request to the live Firebase user for this checkout's UID.
 * A restored buyer object may be stale on cold start; every request and SSE
 * reconnect reads a token from the live object, then rejects its replacement.
 * Anonymous transports serve public ticket discovery only: private operations
 * remain rejected by the server.
 *
 * Every request also carries the device region (`region`, as the app's main
 * API reads send it: `country-code`), signed in or not: the server reads the
 * fan country from it, after a signed-in fan's plan country (the listing
 * design's §5). */
export function vendorHeaders(
  buyer: { uid: string; getIdToken(): Promise<string> } | null,
  current: () => { uid: string; getIdToken(): Promise<string> } | null,
  region?: () => string,
): () => Promise<Record<string, string>> {
  let bound: { uid: string; getIdToken(): Promise<string> } | null = null;
  const where = (): Record<string, string> =>
    region ? { "country-code": region() } : {};
  return async (): Promise<Record<string, string>> => {
    if (!buyer) return where();
    const live = current();
    if (!live || live.uid !== buyer.uid || (bound && live !== bound))
      throw new Error("Checkout sign-in changed.");
    bound ??= live;
    const token = await live.getIdToken();
    // Token acquisition may have crossed an account change.
    if (current() !== live) throw new Error("Checkout sign-in changed.");
    return { authorization: `Bearer ${token}`, ...where() };
  };
}
